<template>
    <div class="main-content">
        <el-container style="height: 680px; border: 1px solid #eee">
            <el-aside width="250px" style="background-color: rgb(238, 241, 246)">
                <el-menu :default-openeds="['0']">
                    <el-button style="width:100%" @click="addCompany" v-if="orgNode==null">添加公司</el-button>
                    <el-submenu index="0" @contextmenu.native="handleRightClick($event,orgNode)" v-if="orgNode!=null">
                        <template slot="title"><i class="el-icon-user-solid"></i>{{orgNode.name}}</template>
                        <el-menu-item v-for="(siteNode,i) in orgNode.companyList" :index="'1'+i" style="height:45px"
                                      @contextmenu.native.stop="itemRightClick($event,siteNode)"  @click.native="getOrgList(siteNode.id)">
                            <i class="el-icon-s-home"></i>{{siteNode.name}}
                        </el-menu-item>
                    </el-submenu>
                    <span v-if="orgNode==null" style="color:red;text-align:center;width:90%;margin-left:25%">未添加公司</span>
                </el-menu>
            </el-aside>

            <el-container>
                <el-main>
                    <el-tabs  v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane name="1" label="公司人员详情列表">
                            <el-form :inline="true" :model="searchForm" class="form-content">
                                <el-row :gutter="20" class="slt">
                                    <el-form-item label="账号">
                                        <el-input prefix-icon="el-icon-search" v-model="searchForm.account" placeholder="账号"   clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="姓名">
                                        <el-input prefix-icon="el-icon-search" v-model="searchForm.fullName" placeholder="姓名"   clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="手机">
                                        <el-input prefix-icon="el-icon-search" v-model="searchForm.mobile" placeholder="手机"   clearable></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="success" @click="getUserList()">查询<i class="el-icon-search el-icon--right"/>
                                        </el-button>
                                        <el-button  type="success"
                                                    icon="el-icon-plus" @click="addOrUpdateUserHandler({})">添加用户
                                        </el-button>
                                    </el-form-item>
                                </el-row>

                            </el-form>
                            <el-table :data="dataList">
                                <el-table-column label="索引"  type="index" width="50"></el-table-column>
                                <el-table-column prop="fullName" align="center" label="姓名"></el-table-column>
                                <el-table-column prop="account" align="center" label="账号"></el-table-column>
                                <el-table-column prop="islock" align="center" label="是否锁定">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.islock=='1'">正常</span>
                                        <span v-if="scope.row.islock=='0'">锁定</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="status" align="center" label="状态">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.status=='0'">锁定</span>
                                        <span v-if="scope.row.status=='1'">正常</span>
                                        <span v-if="scope.row.status=='-1'">删除</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="mobile" align="center" label="手机"></el-table-column>
                                <el-table-column prop="sex" align="center" label="性别">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.sex=='1'">男</span>
                                        <span v-if="scope.row.sex=='2'">女</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="300" align="center"  label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="primary" icon="el-icon-edit" size="mini"  @click="addOrUpdateUserHandler(scope.row)">修改</el-button>
                                        <el-button type="primary" icon="el-icon-edit" size="mini"  @click="resetPassword(scope.row)">重置密码</el-button>
                                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteHandler(scope.row.id)"
                                        >删除</el-button>

                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                    clsss="pages"
                                    :layout="layouts"
                                    @size-change="sizeChangeHandle"
                                    @current-change="currentChangeHandle"
                                    :current-page="pageIndex"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="Number(10)"
                                    :total="totalPage"
                                    class="pagination-content"
                                    style="text-align:right"
                            ></el-pagination>
                        </el-tab-pane>

                    </el-tabs>
                </el-main>
            </el-container>
        </el-container>
        <!--右键点击菜单-->
        <el-menu
                :default-active="1312"
                class="el-menu-demo"
                mode="vertical"
                :collapse="isCollapse"
                v-show="menuShow"
                @close="hideMenu"
                @open="openItem"
                ref="menuRef"
                @mouseleave="menuMouseLevel"
                :style="{ left: left + 'px', top: top + 'px' }"
        >
            <el-sub-menu index="2">
                <el-menu-item index="2-1" @click="addOrg" v-show="addCompanyShow">添加</el-menu-item>
                <el-menu-item index="2-2" @click="editOrg">编辑</el-menu-item>
                <el-menu-item index="2-3" @click="delOrg" v-show="delBtn">删除</el-menu-item>
<!--                <el-menu-item index="2-4" @click="addUser">添加代理人</el-menu-item>-->
                <el-menu-item index="2-5" @click="hideMenu">取消</el-menu-item>
            </el-sub-menu>
        </el-menu>
        <add-or-update :show="addOrUpdateFlag" :rowData="rowData" v-on:listenToChildEvent="closeDialog"></add-or-update>
        <commpany-user-list :show="commpanyUserListFlag" :rowData="commpanyRowData" v-on:listenToChildEvent="closeUserListDialog"></commpany-user-list>
        <!--更新用户信息-->
        <user-reset-pass :show="userResetFlag" :rowData="resetPassRowData" v-on:listenToChildEvent="closePassDialog"></user-reset-pass>
        <!--更新用户信息-->
        <user-add-or-update :show="addOrUpdateUserFlag" :rowData="userRowData" :companyAddUserFlag="companyAddUserFlag"  v-on:listenToChildEvent="closeUserDialog"></user-add-or-update>
    </div>
</template>
<script>
    import AddOrUpdate from "./add-or-update";
    import CommpanyUserList from "./commpany-user-list";
    import userResetPass from "../users/user-reset-pass";
    import UserAddOrUpdate from "../users/add-or-update";
    export default {
        components: {
            AddOrUpdate,
            CommpanyUserList,
            userResetPass,
            UserAddOrUpdate
        },
        data() {
            return {
                companyAddUserFlag:true,
                commpanyUserListFlag:false,
                commpanyRowData:{},
                delBtn:true,
                dataList: [],
                activeIndex:'0',
                menuShow:false,
                isCollapse:true,
                menuRef:null,
                left:0,
                top:0,
                addOrUpdateFlag:false,
                rowData:{},
                orgNode:{},
                selectOrgNode:{},
                searchForm:{
                    account:'',
                    fullName:'',
                    mobile:'',
                },
                pageIndex: 1,
                pageSize: 100,
                totalPage: 0,
                contents:null,
                activeName:'1',
                userDataList:[],
                layouts: '',
                addCompanyShow:false,
                userResetFlag:false,
                resetPassRowData:{},
                addOrUpdateUserFlag:false,
                userRowData:{}

            }
        },
        created(){
            this.getSession();
        },

        methods:{
            getSession(){
                this.$http({
                    url: "users/session",
                    method: "get",
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.$storage.set("companyId", data.data.companyId);
                        this.initOrgList();
                        this.getUserList();
                        this.contentStyleChange();
                    }
                });
            },
            showUserList(row){
                this.commpanyUserListFlag = true;
                this.commpanyRowData = row;
            },
            handleRightClick(e,node) {
                node.companyType = '2';
                this.addCompanyShow = true;
                this.selectOrgNode = node;
                //                console.log(node);
                // 阻止默认的右键菜单显示
                this.delBtn = false;
                e.preventDefault();
                this.menuShow = true;
                this.left = e.clientX+1;
                this.top = e.clientY+1;
            },
            itemRightClick(e,node) {
                this.selectOrgNode = node;
                this.delBtn = true;
                // 阻止默认的右键菜单显示
                e.preventDefault();
                this.menuShow = true;
                this.left = e.clientX+1;
                this.top = e.clientY+1;
            },
            hideMenu(){
                this.menuShow = false;
                this.addCompanyShow = false;
                this.selectOrgNode = {};
            },
            openItem(index, indexPath){
                console.log(index, indexPath)
            },
            menuMouseLevel(e){
                this.menuShow = false;
                this.left = 0;
                this.top = 0;
            },
            addOrg(){
                this.menuShow = false;
                this.addOrUpdateFlag = true;
                this.selectOrgNode.type = 'add';
                //this.selectOrgNode.companyType = '';
                this.addCompanyShow = false;
                this.rowData = this.selectOrgNode;
            },
            editOrg(){
                this.menuShow = false;
                this.addOrUpdateFlag = true;
                this.selectOrgNode.type = 'edit';
                this.addCompanyShow = false;
                this.rowData = this.selectOrgNode;
            },
            addOrUpdateHandler(row){
                this.addOrUpdateFlag = true;
                row.type = 'edit';
                this.rowData = row;
            },
            handleClick(tab, event) {
//                console.log(tab, event);
            },
            //删除公司架构
            delOrg(){
                this.menuShow = false;
                var ids = [this.selectOrgNode.id];
                this.addCompanyShow = false;
                this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$http({
                        url: "company/delete",
                        method: "post",
                        data: ids
                    }).then(({data}) => {
                        if(data && data.code === 0){
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.initOrgList();
                                }
                            });
                        }else{
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
            //编辑更新弹窗
            closeDialog(){
                this.addOrUpdateFlag = false;
//                this.initOrgList();
                this.rowData = {};
                this.getSession();
                //this.getDataList();
            },
            closeOrgUserDialog(){
                this.orgUserShow = false;
                this.orgUserRowData = {};
            },
            initOrgList(){
                this.$http({
                    url: "company/getTreeCompanyList",
                    method: "get",
                }).then(({data}) => {
                    if(data && data.code === 0){
                        console.log(data);
                        this.orgNode = data.rootOrg;
                    }
                });
            },
            /*getOrgList(id){
                let params = {
                    page: this.pageIndex,
                    limit: this.pageSize,
                    sort: 't.sn',
                    order:'desc'
                }
                if (this.searchForm.name!= '' && this.searchForm.name!= undefined) {
                    params['t.name'] = '%' + this.searchForm.name + '%'
                }
                if (id!=undefined && id!=''){
                    params['t.path'] = '%'+id+'%';
                }
                params['t.isdelete'] = '0';

                this.$http({
                    url: "company/page",
                    method: "get",
                    params: params
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.dataList = data.data.list;
                        this.totalPage = data.data.total;
                    }else{
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                    this.dataListLoading = false;
                });
            },*/

            getUserList(orgId){
                let commpanyId = this.$storage.get("companyId");
                let params = {"companyId":commpanyId,'sort':'id','page':1,'limit':30,'order':'asc','orgId':orgId};
                if (this.searchForm.account!= '' && this.searchForm.account!= undefined) {
                    params['account'] = '%' + this.searchForm.account + '%'
                }
                if (this.searchForm.fullName!= '' && this.searchForm.fullName!= undefined) {
                    params['fullName'] = '%' + this.searchForm.fullName + '%'
                }
                if (this.searchForm.mobile!= '' && this.searchForm.mobile!= undefined) {
                    params['mobile'] = '%' + this.searchForm.mobile + '%'
                }
                this.$http({
                    url: "users/selectUserPage",
                    method: "get",
                    params:params
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.dataList = data.data.list;
                    }
                });
            },

            formatDate(dateStr){
                let date = new Date(dateStr);
                return date.toLocaleString();
            },
            searchOrgList(e,node){
                e.preventDefault();
                this.getOrgList(node.id);
            },
            //每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getUserList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getUserList();
            },
            addUser(){
                this.orgUserShow = true;
                this.orgUserRowData = this.selectOrgNode;
                this.menuShow = false;
            },


            contentStyleChange() {
                this.contentSearchStyleChange()
                this.contentBtnAdAllStyleChange()
                this.contentSearchBtnStyleChange()
                this.contentTableBtnStyleChange()
                this.contentPageStyleChange()
            },
            contentSearchStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .slt .el-input__inner').forEach(el => {
                        let textAlign = 'left'
                        if(this.contents.inputFontPosition == 2)
                        textAlign = 'center'
                        if (this.contents.inputFontPosition == 3) textAlign = 'right'
                        el.style.textAlign = textAlign
                        el.style.height = this.contents.inputHeight
                        el.style.lineHeight = this.contents.inputHeight
                        el.style.color = this.contents.inputFontColor
                        el.style.fontSize = this.contents.inputFontSize
                        el.style.borderWidth = this.contents.inputBorderWidth
                        el.style.borderStyle = this.contents.inputBorderStyle
                        el.style.borderColor = this.contents.inputBorderColor
                        el.style.borderRadius = this.contents.inputBorderRadius
                        el.style.backgroundColor = this.contents.inputBgColor
                    })
                    if (this.contents.inputTitle) {
                        document.querySelectorAll('.form-content .slt .el-form-item__label').forEach(el => {
                            el.style.color = this.contents.inputTitleColor
                            el.style.fontSize = this.contents.inputTitleSize
                            el.style.lineHeight = this.contents.inputHeight
                        })
                    }
                    setTimeout(() => {
                        document.querySelectorAll('.form-content .slt .el-input__prefix').forEach(el => {
                            el.style.color = this.contents.inputIconColor
                            el.style.lineHeight = this.contents.inputHeight
                        })
                        document.querySelectorAll('.form-content .slt .el-input__suffix').forEach(el => {
                            el.style.color = this.contents.inputIconColor
                            el.style.lineHeight = this.contents.inputHeight
                        })
                        document.querySelectorAll('.form-content .slt .el-input__icon').forEach(el => {
                            el.style.lineHeight = this.contents.inputHeight
                        })
                    }, 10 )
                })
            },
            // 搜索按钮
            contentSearchBtnStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .slt .el-button--success').forEach(el => {
                        el.style.height = this.contents.searchBtnHeight
                        el.style.color = this.contents.searchBtnFontColor
                        el.style.fontSize = this.contents.searchBtnFontSize
                        el.style.borderWidth = this.contents.searchBtnBorderWidth
                        el.style.borderStyle = this.contents.searchBtnBorderStyle
                        el.style.borderColor = this.contents.searchBtnBorderColor
                        el.style.borderRadius = this.contents.searchBtnBorderRadius
                        el.style.backgroundColor = this.contents.searchBtnBgColor
                    })
                })
            },
            // 新增、批量删除
            contentBtnAdAllStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .ad .el-button--success').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllAddFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllAddBgColor
                    })
                    document.querySelectorAll('.form-content .ad .el-button--danger').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllDelFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllDelBgColor
                    })
                    document.querySelectorAll('.form-content .ad .el-button--warning').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllWarnFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllWarnBgColor
                    })
                })
            },
            // 表格
            rowStyle({row, rowIndex}) {
                if (rowIndex % 2 == 1) {
                    if (this.contents.tableStripe) {
                        return {color: this.contents.tableStripeFontColor}
                    }
                } else {
                    return ''
                }
            },
            cellStyle({row, rowIndex}) {
                if (rowIndex % 2 == 1) {
                    if (this.contents.tableStripe) {
                        return {backgroundColor: this.contents.tableStripeBgColor}
                    }
                } else {
                    return ''
                }
            },
            headerRowStyle({row, rowIndex}) {
                return {color: this.contents.tableHeaderFontColor}
            },
            headerCellStyle({row, rowIndex}) {
                return {backgroundColor: this.contents.tableHeaderBgColor}
            },
            // 表格按钮
            contentTableBtnStyleChange() {
            },
            // 分页
            contentPageStyleChange() {
                let arr = []
                if (this.contents.pageTotal) arr.push('total')
                if (this.contents.pageSizes) arr.push('sizes')
                if (this.contents.pagePrevNext) {
                    arr.push('prev')
                    if (this.contents.pagePager) arr.push('pager')
                    arr.push('next')
                }
                if (this.contents.pageJumper) arr.push('jumper')
                this.layouts = arr.join()
                this.contents.pageEachNum = 10
            },
            addCompany(){
                let obj = {id:'',name:'',companyPathname:'',path:'',code:'',type:'add',companyType:'1',companyPathname:''};
                this.addOrUpdateFlag = true;
                this.rowData = obj;
            },
            closeUserListDialog(){
                this.commpanyUserListFlag = false;
                this.commpanyRowData = {};
            },
            resetPassword(rowData){
                this.userResetFlag = true;
                this.resetPassRowData = rowData;
            },
            // 添加/修改
            addOrUpdateUserHandler( row,type) {
                this.addOrUpdateUserFlag = true;
                row.type = type;
                this.userRowData = row;
            },
            closeUserDialog(data){
                this.addOrUpdateUserFlag = false;
                this.getUserList();
            },
            closePassDialog(){
                this.userResetFlag = false;
                this.resetPassRowData = {};
            },
            deleteHandler(id) {
                var ids = id ? [Number(id)] : this.dataListSelections.map(item => {
                    return Number(item.id);
                });

                this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$http({
                        url: "users/realDel",
                        method: "post",
                        data: ids
                    }).then(({data}) => {
                        if(data && data.code === 0){
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.getUserList();
                                }
                            });
                        }else{
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
        }
    };
</script>
<style>
    .el-header {
        background-color: var(--publicMainColor);
        color: #fff;
        line-height: 60px;
    }

    .el-aside {
        color: #303133;
    }
</style>

<style scoped>
    .main-content {
        background: #fff;
        border-radius: 6px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .el-menu-demo {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 100;
        width: 120px;
    }
</style>